import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const MapSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default MapSVG;
